var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search_result",
    on: {
      "click": _vm.select
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "result_id"
  }, [_vm._v(_vm._s(_vm.prefixedAddress))]), _c('p', {
    staticClass: "balance"
  }, [_vm._v(" Balance "), _c('span', [_vm._v(_vm._s(_vm.avaxBalance.toLocaleString(_vm.avaxDenomination)) + " " + _vm._s(_vm.avaxSymbol))])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "symbol_container"
  }, [_c('p', {
    staticClass: "symbol"
  }, [_vm._v("Address")])]);
}]

export { render, staticRenderFns }